/**
 * Application Constants
 * Single source of truth for configuration values
 */

/**
 * Maximum file size for uploads (50MB)
 * Videos larger than this must be cropped before upload
 */
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB in bytes

/**
 * FFmpeg CRF value for compression (higher = smaller file, lower quality)
 * Range: 0 (lossless) to 51 (worst quality)
 * 23 = default, 28 = good balance of size/quality
 */
export const FFMPEG_CRF = 28;

/**
 * FFmpeg preset for encoding speed
 * Options: ultrafast, superfast, veryfast, faster, fast, medium, slow, slower, veryslow
 * veryfast = good balance of speed/compression
 */
export const FFMPEG_PRESET = 'veryfast';

/**
 * Audio bitrate for compressed videos (128kbps = good quality)
 */
export const AUDIO_BITRATE = '128k';

/**
 * Default crop duration for uploaded videos (seconds)
 * Videos are cropped to middle N seconds by default
 */
export const DEFAULT_CROP_DURATION = 1.5;

/**
 * Minimum password length, matching Supabase Auth's own default.
 *
 * Shared so the reset-password page and Edit Profile can't drift apart —
 * a stricter client rule than the server's would reject passwords the server
 * would accept, and a looser one would surface a confusing server error.
 */
export const MIN_PASSWORD_LENGTH = 6;
